<template>
	<section>
        <b-row class="filters-orientation">
            <b-col class="d-block text-parcela mb-3">
                <span class="label-conta">Valor</span>
                <b-form-input
                    name="amount"
                    class="modal-edicao-input number-class"
                    v-model="amount"
                    autocomplete="off"
                    placeholder=""
                    inputmode="numeric"
                    v-validate="'required|noZeroCurrency'"
                    :state="validateState('amount')"
                    @focus="handleFocus('amount')"
                    @blur="handleBlur('amount')"
                    @input="updateValue(amount)"
                    :disabled="disabled"
                />
            </b-col>
        </b-row>
        <b-row class="filters-orientation">
            <b-col class="text-parcela">
                <label class="label-conta mb-0">Frequência</label>
                <vue-multi-select
                    :disabled="disabled"
                    style="margin-top: -7px !important;"
                    class="multi-100 mb-1 style-select"
                    v-model="selectedFrequency"
                    searchPlaceholder="Pesquisar"
                    :options="{ multi: false, labelName: 'text' }"
                    :selectOptions="optionsFrequency"
                    :btnLabel="() => (selectedFrequency.length > 1 ? `${selectedFrequency[0].text}...` : selectedFrequency[0] && selectedFrequency[0].text) || 'Selecione'"
                />
            </b-col>
            <b-col v-if="selectedFrequency.length && selectedFrequency[0].value === 'WEEKLY'" class="text-parcela">
                <label class="label-conta mb-0">Dia da semana</label>
                <vue-multi-select
                    :disabled="disabled"
                    style="margin-top: -7px !important;"
                    class="multi-100 mb-1 style-select"
                    v-model="selectedDayOfWeek"
                    searchPlaceholder="Pesquisar"
                    :options="{ multi: false, labelName: 'text' }"
                    :selectOptions="optionsDayOfWeek"
                    :btnLabel="() => (selectedDayOfWeek.length > 1 ? `${selectedDayOfWeek[0].text}...` : selectedDayOfWeek[0] && selectedDayOfWeek[0].text) || 'Selecione'"
                />
            </b-col>
            <b-col class="text-parcela">
                <label class="label-conta mb-0">Intervalo</label>
                <b-form-input
                    style="margin-top: -7px !important;"
                    name="interval"
                    class="modal-edicao-input number-class"
                    type="number"
                    v-model="interval"
                    autocomplete="off"
                    placeholder=""
                    min="1"
                    v-validate="{ required: true, min_value: 1,  max_value: 31 }"
                    :state="validateState('interval')"
                    :disabled="disabled"
                    @focus="handleFocus('interval')"
                />
            </b-col>
        </b-row>
    </section>
</template>

<script>
	import { numberFormatted, validateNumber, stringToNumber, isNullValue } from "@/helpers/common";
	import { hasFieldsWithErrors } from "@/helpers/validators";

	export default {
		name: "SchedulingRecurring",
		components: {
		},
		props: {
			disabled: {
				type: Boolean,
				required: false,
				default: false
			},
			clearFields: {
				type: Boolean,
				required: false,
				default: false
			},
			strAmount: {
				type: String,
				required: false,
				default: "0"
			},
			intervalEdit: {
				type: String,
				required: false,
				default: "1"
			},
			dayOfWeekEdit: {
				type: String,
				required: false,
				default: "1"
			},
			selectedFrequencyEdit: {
				type: String,
				required: false,
				default: "MONTHLY"
			},
			dayOfMonthEdit: {
				type: String,
				required: false,
				default: "1"
			}

		},

		data () {
			return {
				selectedFrequency: [],
				optionsFrequency: [
					// {
					// 	value: "DAILY",
					// 	text: "Diario"
					// },
					// {
					// 	value: "WEEKLY",
					// 	text: "Semanal"
					// },
					{
						value: "MONTHLY",
						text: "Mensal"
					},
					{
						value: "YEARLY",
						text: "Anual"
					}

				],
				optionsDayOfWeek: [
					{
						value: 0,
						text: "Domingo"
					},
					{
						value: 1,
						text: "Segunda-feira"
					},
					{
						value: 2,
						text: "Terça-feira"
					},
					{
						value: 3,
						text: "Quarta-feira"
					},
					{
						value: 4,
						text: "Quinta-feira"
					},
					{
						value: 5,
						text: "Sexta-feira"
					},
					{
						value: 3,
						text: "Sábado"
					}

				],
				selectedDayOfWeek: [],
				amount: "0",
				interval: null,
				dayOfWeek: null,
				dayOfMonth: null,
				errors: false,
				loading: false
			};
		},

		watch: {
			strAmount (newData) {
				this.amount = newData;
			},

			clearFields () {
				if (!this.clearFields) return;

				this.selectedFrequency = [
					{
						value: "MONTHLY",
						text: "Mensal"
					}
				];
				this.selectedDayOfWeek = [
					{
						value: 1,
						text: "Segunda-feira"
					}
				];
				this.amount = "0";
				this.interval = "1";
				this.dayOfWeek = "1";
				this.errors = false;
				this.loading = false;
				this.dayOfMonth = "1";

				this.emitData();
			}

		},

		async mounted () {
			this.selectedFrequency = this.optionsFrequency.filter(ele => ele.value === this.selectedFrequencyEdit);
			this.selectedDayOfWeek = this.optionsDayOfWeek.filter(ele => ele.value === this.dayOfWeekEdit);
			this.interval = this.intervalEdit;
			this.dayOfWeek = this.dayOfWeekEdit;
			this.dayOfMonth = this.dayOfMonthEdit;
			this.amount = await validateNumber(this.strAmount);

			this.emitData();
		},

		methods: {
			async updateValue (value) {
				this.amount = await validateNumber(value);
			},

			validateState (ref) {
				this.errors = hasFieldsWithErrors(this.veeFields);
				this.$emit("error", this.errors);
				this.emitData();

				if (
					this.veeFields[ref]
					&& (this.veeFields[ref].dirty || this.veeFields[ref].validated)
				) {
					return !this.veeErrors.has(ref);
				}

				return null;
			},

			handleFocus (key) {
				if (isNullValue(this[key])) {
					this[key] = "";
				} else {
					if (typeof this[key] === "string")
						this[key] = this[key].replace(/\./g, "");
				}
			},

			handleBlur (key) {
				this[key] = this[key] && numberFormatted(stringToNumber(this[key]));

			},

			emitData () {
				const amount = this.amount.replace(".", "").replace(",", ".");
				const data = {
					dayOfMonth: this.dayOfMonth,
					amount,
					interval: this.interval,
					frequency: this.selectedFrequency[0]?.value || null,
					dayOfWeek: this.selectedDayOfWeek[0]?.value || null
				};

				this.$emit("data", data);
			}
		}
	};
</script>